<template>
  <div>
    <ProductInfo
      :product="product"
      :site="site"
    />
    <Inventory
      v-if="hasPermission('productInventory.view')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProductInfo from '@/views/associatedProducts/ProductInfo';
import Inventory from '@/views/associatedProducts/Inventory.vue';

export default {
    components: {
        ProductInfo,
        Inventory,
    },
    computed: {
        ...mapGetters([
            'lang',
            'product',
            'site',
            'hasPermission',
        ]),
    },
    watch: {
        lang() {
            this.reloadSiteProduct({
                siteId: this.site.id,
                productId: this.product.id,
            });
        },
    },
    methods: {
        ...mapActions({
            reloadSiteProduct: 'getSiteProductInfo',
        }),
    },
};
</script>
